import React, { ReactNode } from 'react';
import Box from '../Box/Box';
import { TUtils } from '../../types/TUtils';

// https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements
// https://github.com/webmodules/block-elements

type TButtonsBlock = {
  kind?: '' | 'adaptive' | 'fixed';
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
} & TUtils;

const ButtonsBlock = ({ kind = '', ...rest }: TButtonsBlock) => (
  <Box {...rest} name="ButtonsBlock" modifiers={kind} as="div" />
);

export default ButtonsBlock;
